(() => {
  document.querySelectorAll('[data-size-finder]').forEach(finder => {
    if (finder.dataset.ready) return;
    finder.dataset.ready = 'true';
    const underInput = finder.querySelector('[data-size-under]');
    const bustInput = finder.querySelector('[data-size-bust]');
    const unit = finder.querySelector('[data-size-unit]');
    const result = finder.querySelector('[data-size-result]');
    const dialog = finder.closest('dialog');
    const unitTabs = [...dialog.querySelectorAll('[data-unit]')];
    const storageKey = 'lumora-size-finder';
    let exactMeasurements = null;
    function saveMeasurements() {
      try {
        localStorage.setItem(storageKey, JSON.stringify({
          underbust: underInput.value, bust: bustInput.value, unit: unit.value, exactMeasurements
        }));
      } catch (_) {}
    }
    function findSize() {
      if (!underInput.value || !bustInput.value) { result.textContent = ''; return; }
      const factor = unit.value === 'cm' ? 2.54 : 1;
      const under = exactMeasurements ? exactMeasurements.under : Number(underInput.value) / factor;
      const bust = exactMeasurements ? exactMeasurements.bust : Number(bustInput.value) / factor;
      if (!Number.isFinite(under) || !Number.isFinite(bust) || under <= 0 || bust <= under) {
        result.textContent = 'Enter valid measurements. Bust must be larger than underbust.';
        return;
      }
      const table = dialog.querySelector('.bra-size-chart__matrix');
      const rows = [...table.querySelectorAll('tbody tr')];
      const cups = [...table.querySelectorAll('thead [data-chart-measure]')];
      const contains = (element, value, last) => {
        const [low, high] = element.dataset.chartMeasure.split(',').map(Number);
        return value >= low - 1e-8 && (value < high - 1e-8 || (last && value <= high + 1e-8));
      };
      const row = rows.find((row, index) => contains(row.querySelector('[data-chart-measure]'), under, index === rows.length - 1));
      const cupIndex = cups.findIndex((cup, index) => contains(cup, bust - under, index === cups.length - 1));
      if (!row || cupIndex < 0) {
        result.textContent = 'Your measurements are outside this chart. Contact us for help choosing your size.';
        return;
      }
      const cell = row.children[cupIndex + 2];
      if (!cell.dataset.fitSize) {
        result.textContent = 'This combination has no size listed. Contact us for help finding your fit.';
        return;
      }
      result.textContent = 'Recommended size: ' + cell.dataset.fitSize + ' (' + cell.querySelector('small').textContent + ').';
    }
    [underInput, bustInput].forEach(input => {
      input.addEventListener('keydown', event => {
        if (event.key === 'Enter') { event.preventDefault(); findSize(); }
      });
      input.addEventListener('input', () => {
        exactMeasurements = null;
        saveMeasurements();
        findSize();
      });
    });
    unit.addEventListener('change', () => {
      const previousFactor = unit.value === 'cm' ? 1 : 2.54;
      if (!exactMeasurements) exactMeasurements = { under: Number(underInput.value) / previousFactor, bust: Number(bustInput.value) / previousFactor };
      const factor = unit.value === 'cm' ? 2.54 : 1;
      [[underInput, exactMeasurements.under], [bustInput, exactMeasurements.bust]].forEach(([input, inches]) => {
        if (input.value && inches > 0) input.value = String(Math.round(inches * factor * 1000000) / 1000000);
      });
      saveMeasurements();
      findSize();
      const tab = unitTabs.find(tab => tab.dataset.unit === unit.value);
      if (tab && tab.getAttribute('aria-pressed') !== 'true') tab.click();
    });
    unitTabs.forEach(tab => tab.addEventListener('click', () => {
      if (unit.value === tab.dataset.unit) return;
      unit.value = tab.dataset.unit;
      unit.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    new MutationObserver(() => {
      if (!dialog.open) return;
      const tab = unitTabs.find(tab => tab.dataset.unit === unit.value);
      if (tab && tab.getAttribute('aria-pressed') !== 'true') tab.click();
    }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
    try {
      const saved = JSON.parse(localStorage.getItem(storageKey) || 'null');
      if (saved && (saved.unit === 'in' || saved.unit === 'cm')) {
        unit.value = saved.unit;
        if (typeof saved.underbust === 'string') underInput.value = saved.underbust;
        if (typeof saved.bust === 'string') bustInput.value = saved.bust;
        if (Number.isFinite(saved.exactMeasurements?.under) && Number.isFinite(saved.exactMeasurements?.bust)) exactMeasurements = saved.exactMeasurements;
      }
    } catch (_) {}
    findSize();
  });
})();
